import { creatorCategories } from "@/mocks/creatorDirectory";

interface CategoriesProps {
  onPickCategory: (category: string) => void;
}

export default function Categories({ onPickCategory }: CategoriesProps) {
  return (
    <section id="categories" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-layout-grid-line"></i>
            按内容领域找
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            八大常青内容领域
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
            先想清楚自己平时愿意花时间看什么，再从对应领域里挑创作者，命中率最高。
            点击任意领域，可直接跳到下方对应的创作者名单。
          </p>
        </div>

        <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
          {creatorCategories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => onPickCategory(cat.key)}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/10 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <i className="ri-arrow-right-up-line text-lg text-foreground-400 transition-colors group-hover:text-primary-600"></i>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
              <p className="mt-3 inline-flex items-center gap-1.5 text-[11px] font-medium text-accent-700">
                <i className="ri-flashlight-line"></i>
                {cat.highlight}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}